// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { CustomFileInput } from "./CustomFileInput";
import {
  instanceOfCustomFileInput,
  CustomFileInputFromJSON,
  CustomFileInputFromJSONTyped,
  CustomFileInputToJSON,
} from "./CustomFileInput";
import type { DrawOnMapInput } from "./DrawOnMapInput";
import {
  instanceOfDrawOnMapInput,
  DrawOnMapInputFromJSON,
  DrawOnMapInputFromJSONTyped,
  DrawOnMapInputToJSON,
} from "./DrawOnMapInput";
import type { StandardAreaInput } from "./StandardAreaInput";
import {
  instanceOfStandardAreaInput,
  StandardAreaInputFromJSON,
  StandardAreaInputFromJSONTyped,
  StandardAreaInputToJSON,
} from "./StandardAreaInput";

/**
 * @type DefineStudyAreaInputArea
 *
 * @export
 */
export type DefineStudyAreaInputArea = CustomFileInput | DrawOnMapInput | StandardAreaInput;

export function DefineStudyAreaInputAreaFromJSON(json: any): DefineStudyAreaInputArea {
  return DefineStudyAreaInputAreaFromJSONTyped(json, false);
}

export function DefineStudyAreaInputAreaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DefineStudyAreaInputArea {
  if (json == null) {
    return json;
  }
  if (typeof json !== "object") {
    return json;
  }
  if (instanceOfCustomFileInput(json)) {
    return CustomFileInputFromJSONTyped(json, true);
  }
  if (instanceOfDrawOnMapInput(json)) {
    return DrawOnMapInputFromJSONTyped(json, true);
  }
  if (instanceOfStandardAreaInput(json)) {
    return StandardAreaInputFromJSONTyped(json, true);
  }
  return {} as any;
}

export function DefineStudyAreaInputAreaToJSON(json: any): any {
  return DefineStudyAreaInputAreaToJSONTyped(json, false);
}

export function DefineStudyAreaInputAreaToJSONTyped(
  value?: DefineStudyAreaInputArea | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }
  if (typeof value !== "object") {
    return value;
  }
  if (instanceOfCustomFileInput(value)) {
    return CustomFileInputToJSON(value as CustomFileInput);
  }
  if (instanceOfDrawOnMapInput(value)) {
    return DrawOnMapInputToJSON(value as DrawOnMapInput);
  }
  if (instanceOfStandardAreaInput(value)) {
    return StandardAreaInputToJSON(value as StandardAreaInput);
  }
  return {};
}
